<template>
  <div class="container">
    <div class="pictures">
      <picture-thumbnail
        v-for="(picture, index) in pictures"
        :key="index"
        :picture="picture"
        @click="$emit('selectPicture', index + 1)"
      />
    </div>
  </div>
</template>

<script>
import PictureThumbnail from "@/components/PictureThumbnail";

export default {
  components: {
    PictureThumbnail,
  },
  props: {
    pictures: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.pictures {
  margin-top: 60px;
  column-count: 1;
  column-gap: 30px;

  @media (min-width: 640px) {
    column-count: 2;
  }

  @media (min-width: 1024px) {
    column-count: 3;
  }

  @media (min-width: 1250px) {
    column-count: 4;
  }
}
</style>
